import { useParams, Link } from "react-router-dom";
import publications from "../data/publicationsData";

const PublicationDetails = () => {
  const { id } = useParams();
  const publication = publications.find((item) => item.id === id);

  if (!publication) {
    return (
      <section className="bg-brandBlue text-white font-outfit px-6 py-16 min-h-screen">
        <p className="text-center">Publication not found.</p>
        <div className="text-center mt-6">
          <Link
            to="/publications"
            className="inline-block bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition"
          >
            ← Back to Publications
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-brandBlue relative text-white font-outfit px-6 py-16 xs:py-8 xxs:py-8 min-h-screen overflow-hidden">
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-softGreen/30 blur-3xl rounded-full z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-brandGreen/20 blur-3xl rounded-full z-0" />

      <article className="max-w-3xl mx-auto relative z-[12]">
        <Link
          to="/publications"
          className="inline-block mb-8 bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition"
        >
          ← Back to Publications
        </Link>

        {publication.image && (
          <div className="mb-8 rounded-2xl overflow-hidden">
            <img
              src={publication.image}
              alt=""
              className="w-full h-56 md:h-72 object-cover"
            />
          </div>
        )}

        <p className="text-sm text-[#04DDAD] mb-2">{publication.category}</p>
        <h1 className="text-3xl xs:text-2xl xxs:text-2xl font-bold mb-8 leading-tight">
          {publication.title}
        </h1>

        <div className="space-y-5 text-lg xs:text-base xxs:text-base text-gray-200 leading-relaxed">
          {(publication.content || [publication.description]).map(
            (paragraph, index) => (
              <p
                key={index}
                className={
                  index === 0
                    ? "text-[#04DDAD] font-medium italic border-l-2 border-[#04DDAD] pl-4"
                    : ""
                }
              >
                {paragraph}
              </p>
            ),
          )}
        </div>

        {publication.tags?.length > 0 && (
          <div className="mt-10 flex flex-wrap gap-2">
            {publication.tags.map((tag) => (
              <span
                key={tag}
                className="text-xs text-[#04DDAD] border border-[#04DDAD]/40 rounded-lg px-3 py-1"
              >
                #{tag}
              </span>
            ))}
          </div>
        )}
      </article>
    </section>
  );
};

export default PublicationDetails;
